import { AxiosHttpClient } from 'api/axios';
import { useRepruaPostApi } from 'api/shared_api_hooks';
import { ApprovalResult, ApprovalResultForm } from 'entities/approval_result';
import { ApiSet, BaseResponse, Form } from 'rac';

type ApprovalResultResponse = BaseResponse & {
  approvalResult: ApprovalResult;
};

/**
 * 作成
 */
export function usePostEstimateApprovalResultApi(): ApiSet<ApprovalResultResponse> & {
  execute: (form: Form<ApprovalResultForm>) => void;
} {
  const api = useRepruaPostApi<ApprovalResultResponse, ApprovalResultForm>(new AxiosHttpClient('user'), {
    initialResponse: { approvalResult: {} },
  });

  const execute = (form: Form<ApprovalResultForm>) => {
    const path = 'approval_results';
    api.execute(path, form);
  };
  return { ...api, execute };
}
